import { ObjectValues } from 'src/common/tsHelpers';

export const SIMULATE_OUTAGE_FILTER = {
  ON: 'ON',
  OFF: 'OFF',
  ANY: 'ANY',
} as const;

export type SimulateOutageFilter = ObjectValues<typeof SIMULATE_OUTAGE_FILTER>;

export const SIMULATED_OUTAGE_STATUS = {
  NONE: 0,
  PRIMARY: 1,
  SECONDARY: 2,
  BOTH: 3,
} as const;

export type SimulatedOutageStatus = ObjectValues<typeof SIMULATED_OUTAGE_STATUS>;

export const mapSimulateOutageFilterToDisplayLabel = (value: SimulateOutageFilter) => {
  switch (value) {
    case SIMULATE_OUTAGE_FILTER.ANY:
      return null;
    case SIMULATE_OUTAGE_FILTER.OFF:
      return 'off';
    case SIMULATE_OUTAGE_FILTER.ON:
      return SIMULATE_OUTAGE_FILTER.ON;
  }
};
